import { TitleBlockTemplate, TitleBlockCell } from '@/app/types/titleblock';

// =============================================================================
// DEFAULT EMPTY TITLE BLOCK TEMPLATE (4 Columns x 10 Rows)
// =============================================================================

export const DEFAULT_TEMPLATE_ID = 'default-empty-v1';

export const getFahnerTemplate = (): TitleBlockTemplate => {
  const cells: TitleBlockCell[] = [];
  let cellIdCounter = 1;
  const addCell = (c: Omit<TitleBlockCell, 'id'>) => {
    cells.push({ ...c, id: `cell-${cellIdCounter++}` });
  };

  const bStd = { show: true, width: 0.25, color: 'black' };

  // 4 Columns: 45mm each (Total 180mm)
  const colWidths = [45, 45, 45, 45];

  // 10 Rows: 6mm each (Total 60mm)
  // Adjusted to be a reasonable height for a title block
  const rowHeights = Array(10).fill(6);

  // Generate 4x10 Grid
  for (let r = 0; r < 10; r++) {
    for (let c = 0; c < 4; c++) {
      addCell({
        rowIndex: r,
        colIndex: c,
        type: 'text',
        value: '',
        styles: {
          borderRight: bStd,
          borderBottom: bStd,
          // Left border handled by container or previous cell
          // Top border handled by container or previous row
        }
      });
    }
  }

  return {
    id: DEFAULT_TEMPLATE_ID,
    name: 'Standard Leerer Plankopf',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    columns: colWidths,
    rows: rowHeights,
    cells: cells,
    defaultStyles: {
      fontFamily: 'Arial, sans-serif',
      fontSize: 2.5,
      color: 'black',
      padding: 1
    }
  };
};
